<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择患者</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <el-form :model="searchForm" inline ref="searchForm">
                        <div>
                            <el-col :span="24">
                                <el-form-item prop="phone">
                                    <el-input  placeholder="请输入手机号" v-model="searchForm.phone" maxlength="11" clearable style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>
                                <el-form-item prop="idCard">
                                    <el-input  placeholder="请输入身份证号" v-model="searchForm.idCard" clearable maxlength="18" style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>
                                <!-- <el-form-item prop="status">
                                    <el-select v-model="searchForm.status" placeholder="请选择状态" style="width:200px;margin-right:10px">
                                        <el-option
                                                v-for="(item,i) in statusValue"
                                                :key="i"
                                                :label="item"
                                                :value="i">
                                        </el-option>
                                    </el-select>
                                </el-form-item> -->
                                <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                            </el-col>
                        </div>
                    </el-form>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border :height="th">
                            <el-table-column label="名称" prop="name"></el-table-column>
                            <el-table-column label="手机号" prop="phone"></el-table-column>
                            <el-table-column label="身份证号" prop="idCard"></el-table-column>
                            <el-table-column label="详细住址" prop="address" ></el-table-column>
                            <el-table-column prop="balance"  label="余额(元)"></el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="handleRecharge(scope.$index, scope.row)">充值</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）
                    </div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>
        </div>
        <Recharge ref="myRecharge" v-show="showModalRecharge" v-on:closeRecharge="closeRecharge"  v-on:getList="getList"></Recharge>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import Recharge from "./Recharge"


    export default {
        name: 'Add',
        props:['zoneValue'],
        data() {
            return {
                showModalRecharge:false,
                multipleSelection:'',
                checked:false,
                loading: false, 
                elderlyInfo:[],
                statusValue:['全部状态','正常','禁用'],
                totalItems:0,
                searchForm:{
                    phone:'',
                    idCard:'',
                    status:0,
                    pageSize:20,
                    pageIndex:1,
                },
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight,
                
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val
            },
        },
        components:{
            Recharge
        },
        methods: {
            init(){
                this.$refs.searchForm.resetFields()
                console.log(this.bodyStyle)
                this.getElderly()
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            changeThreeDay(){
                this.checked?this.searchForm.isRecharge=1:this.searchForm.isRecharge=0;
                this.getElderly()
            },
            getList(){
                this.$emit("getList");
                this.getElderly();
            },
            current_change:function(currentPage){
                this.searchForm.pageIndex = currentPage;
                this.getElderly();
            },
            handleRecharge(index, row) {
                this.$refs.myRecharge.init(row);
                this.showModalRecharge = !this.showModalRecharge;
            },
            closeRecharge:function(){
                this.showModalRecharge = !this.showModalRecharge;
            },
            elderlyTypes(row){
                if(row.elderlyType == 0){
                    return "政府购买服务";
                }
                if(row.elderlyType == 1){
                    return "有偿服务";
                }
                return "其它";
            },
            allStatus(row,status){
                for(var i in status){
                    if(status[i].value==row){
                        return status[i].label
                    }
                }
                return "其它";
            },
            getZoneValue(val){
                this.searchForm.zoneCode=val
            },
            getElderly(){
                this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.searchForm.timeStr = timeStr
                this.searchForm.staffCode = getStaffCode()
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Patient/Page",
                    data: this.searchForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-form-item{
                margin: 0 5px 0 0;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
